<template>
  <div>
    <table style="position: absolute;" width="100%" :height="this.windowSize.height - 8"
      :max-height="this.windowSize.height - 8">
      <tr max-height="48px" height="48px">

        <ContenidoBase :titulo="'Reporte Diario de Compras'" :descripcion="'Imprime las Compras a Proveedores.'"
          :EstadoBtn="EstadoBtn" @abrirBarraTablaDinamica="abrirTabla" @MethodNuevo="newwnuevo" @MethodGuardar="save"
          @MethodEliminar="remove" @MethodAnular="anular" @MethodImprimir="imprimirList" />
      </tr>


      <tr>
        <!-- BarraPrimaria --------------------------------------------------------------------------------->
        <td width="109" :max-height="this.windowSize.height - 96" v-show="BarraTablaDinamicaAprir">

          <div class="overflow-y-auto "
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', 'width': '325px' }">

            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <center>
                  <v-btn-toggle>
                    <v-btn small color="yellow accent-4" @click.prevent="actualiza_tb_ver">
                      <i style="font-size: 25px;" class="fa fa-eye"> </i> ver
                    </v-btn>
                    <v-btn small dark color="deep-purple accent-2"
                      @click.prevent="notifi('Seguro que desea nuevo', 'n')">
                      <i style="font-size: 25px;" class="fa fa-print"> </i>
                      Listado
                    </v-btn>
                  </v-btn-toggle>
                </center>
                <!-- <BarraBusqueda2
              :url="
                $hostname + $hName + '/services/tipocliente/findalltipoclientes'
              "
              :nombre="'Tipo de Clientes'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitReportesDiarioCompras'"
              :SeachNombre="'Búsqueda por descripcion '"
              :slotlist="slotlist"
            /> -->
              </template>
            </v-tooltip>

          </div>
        </td>
        <!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
        <!-- contenido central ------------------------------------------------------------------------------ -->
        <td :max-height="this.windowSize.height - 96">
          <v-app id="inspire" class="overflow-y-auto " v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }">


            <v-container>
              <v-card color="grey lighten-3">

                <v-toolbar flat color="#BDBDBD" dense style="border: 1px solid #000000;">


                  <v-avatar tile size="45">
                    <img src="@/assets/iconos_micromarket/custom-reports.png" alt="Reporte">
                  </v-avatar>


                  <span class="font-weight-light" style="font-size: 20px;"> Diario de Compras </span>

                  <!-- <v-toolbar-title    class="font-weight-light"> Reporte Producción de boletos por unidades</v-toolbar-title > -->
                  <!-- style="color:white;" -->
                  <!-- <i class=""> </i> -->

                  <!-- <v-spacer></v-spacer> -->
                  <!-- <v-btn
          color="grey darken-4"
          fab
          small
          @click="cerrarmodalcuenta"
        >
         <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
        </v-btn> -->
                </v-toolbar>

                <hr>

                <v-container style="border: 1px solid #000000;">
                  <v-form ref="form" @submit.prevent="" v-model="valid" lazy-validation>
                    <v-row>
                      <!-- columna 1 -->
                      <v-col cols="12" md="6" sm="6">

                        <!-- -----------------------------  desde  -->
                        <v-text-field dense outlined type="date" label="Desde:" :rules="[$rules.required]"
                          v-model="DiarioCompras.desde" @blur="BlurDesde">
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-calendar"></i>
                          </template>
                        </v-text-field>

                        <!-------------------------------------------------- proveedor -->
                        <v-combobox autocomplete="off" dense outlined label="Proveedor:" :items="Rproveedor"
                          item-text="nombre" v-model="DiarioCompras.proveedor" @blur="SelctCbProveedor"
                          @focus="cargarProveedor" @keyup="CbFilProveedor">
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-user-circle"></i>
                          </template>
                        </v-combobox>
                        <!-- ----------------------------- Documentos -->
                        <v-combobox autocomplete="off" dense outlined label="Documentos:" :items="RDocumento"
                          item-text="descripcion" v-model="DiarioCompras.documento" @focus="cargarDocumento"
                          @blur="SelctCbDocumento">
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-file-text-o"></i>
                          </template>
                        </v-combobox>

                      </v-col>
                      <!-- fn columna 1 -->


                      <!-- columna 2 -->
                      <v-col cols="12" md="6" sm="6">


                        <!-- -----------------------------  hasta  -->
                        <v-text-field dense outlined type="date" label="Hasta:" :rules="[$rules.required]"
                          v-model="DiarioCompras.hasta" @blur="BlurHasta">
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-calendar"></i>
                          </template>
                        </v-text-field>
                        <!-- ----------------------------- Tipo Factura -->
                        <v-combobox autocomplete="off" dense outlined label="Tipo Factura:" :items="RTipoFactura"
                          item-text="descripcion" v-model="DiarioCompras.tipoFactura" @blur="SelctCbTipoFactura">
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-wpforms"></i>
                          </template>
                        </v-combobox>
                      </v-col>
                      <!-- fn columna 2 -->

                    </v-row>

                  </v-form>
                </v-container>

                <hr>

                <ModalReporteFiltros2 ref="ModRepFilt" @DataReporteBasico="DDataReporteBasico"
                  :Datos="DiarioComprasLink" />


              </v-card>
            </v-container>

          </v-app>
        </td>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
        <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
        <td width="109" :max-height="this.windowSize.height - 96" v-show="BarraSecundariaAprir">

          <div class="overflow-y-auto "
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', 'width': '325px' }">

            <!--         
        <BarraBusqueda2
              :url="$hostname + $hName + '/services/caja/findAll'"
              :nombre="'Cajas'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitCaja'"
              :slotlist="slotlist"
              :SeachNombre="'Búsqueda por descripción caja'"
            /> -->
          </div>

        </td>
        <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->



      </tr>
    </table>
    <!-- Modales -------------------------------------------------------------------------------------------------->
    <!-- ------------------------------------------------------ tb-data-->
    <v-dialog label="myAlert" v-model="acti_tb_data" persistent max-width="100%" max-height="100%"
      transition="fab-transition">
      <v-card>
        <v-toolbar flat color="#BDBDBD">
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"></i>
          <v-toolbar-title class="font-weight-light"> REPORTE </v-toolbar-title>
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"> </i>

          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small @click="acti_tb_data = !acti_tb_data">
            <i style="font-size: 20px; color:#dd4b39;" class="fa fa-close"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field v-model="search" @keyup="filtro" label="Buscar" single-line hide-details>
                <template v-slot:prepend-inner>
                  <i style="font-size: 35px;" class="fa fa-search"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table :headers="slotHtabla" dense :items="list" :search="search" @click:row="datostabla">
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Elim_notif-->
    <v-dialog label="myAlert" v-model="Elim_notif.estado" persistent max-width="350" transition="fab-transition">
      <template justify="center" v-slot:activator="{ on }"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i style="font-size: 28px;" class="fa fa-warning"></i>
            CONFIRMACION
            <i style="font-size: 28px;" class="fa fa-warning"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ Elim_notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn @click.prevent="
            eliminar(), (Elim_notif.estado = !Elim_notif.estado)
          " small>
            <i style="font-size: 20px;" class="fa fa-check"></i> Si
          </v-btn>

          <v-btn @click.prevent="Elim_notif.estado = !Elim_notif.estado" small>
            <i style="font-size: 20px;" class="fa fa-ban"></i> No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Elim_notif -->

    <!------------otras funciones---------------->
    <v-snackbar v-model="aalert.estado" :color="aalert.color" style="margin-top: 20%;" :vertical="true"
      :timeout="120000" top="top">
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- fn Modales ----------------------------------------------------------------------------------------------->


  </div>
</template>

<script>
import { EventBus } from "../../event-bus";
import BarraBusqueda2 from "../../components/BarraBusquedaDinam";
import ContenidoBase from "../../components/ContenidoBase";
// import ModalReporteFiltros from "../../components/ModalReporteFiltros";
 import ModalReporteFiltros2 from "../../components/ModalReporteFiltros2";
import { currencyFormatter,
  FormatoFecha,
  HoraFormatter,
  HoraFormatter2,
  RedondeoValor,
  RedondeoBasico,
  RedondeoValorCantRed,
  fechaNueva,
  getParamFecha
} from "@/js/Funciones.js";
export default {
  components: {
    BarraBusqueda2,
    ContenidoBase,
    ModalReporteFiltros2
  },
  created() {
    var json = {
      titulo: "Reporte Diario de Compras",
      descripcion: "Imprime las Compras a Proveedores.",
      save: false,
      eliminar: false,
      anular: false,
      nuevo: false,
      imprimir: false,
      accion: [

        "ReportesDiarioComprasNew",
        "ReportesDiarioComprasSave",
        "ReportesDiarioComprasRemove",
        "ReportesDiarioComprasAnular",
        "ReportesDiarioComprasPrintList"
      ],
    };
    EventBus.$emit("anularBotonesAccion", json);
  },
  mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla);
    // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    EventBus.$on("ReportesDiarioComprasNew", this.new);
    EventBus.$on("ReportesDiarioComprasSave", this.save);
    EventBus.$on("ReportesDiarioComprasRemove", this.remove);
    EventBus.$on("ReportesDiarioComprasAnular", this.remove);
    EventBus.$on("ReportesDiarioComprasPrintList", this.imprimirList);
    EventBus.$on("emitReportesDiarioCompras", this.datostabla);
    EventBus.$on("onResize", this.onResize);

    this.$refs.ModRepFilt.CrearObjecto = this.validarObjecto;
  },

  data: () => ({

    Rpropietario: [],
    Rproveedor: [],
    RDocumento: [],
    RCaja: [],
    RTipoFactura: [{ codigo: 1, descripcion: 'CONTADO' }, { codigo: 2, descripcion: 'CREDITO' }],
    ListaTiposClientes: [],
    windowSize: { width: "auto", height: "auto" },

    DiarioComprasLink: {
      nombre: 'REPORTE DIARIO DE COMPRAS',
      UrlImprimir: '/reportesCXP/diariocompra',
      UrlExel: '/reportesCXP/ExcelListdiariocompra',
      UrlCorreo: '/reportesCXP/CorreoListdiariocompra',
      documentoFiltro: "",
    },


    DiarioCompras: {
      desde: fechaNueva(),
      hasta: fechaNueva(),
      tipoFactura: null,
      proveedor: null,
      documento: null
    },

    EstadoBtn: {
      BarraTablaDinamicaAprir: false,
      nuevo: false,
      guardar: false,
      eliminar: false,
      anular: false,
      imprimir: false,
      vercuenta: false,
      guardartemporal: false,
      restaurartemporal: false,
      importarDato: false,
      cargarProducto: false,
      ImprimirproductoInv: false,
    },

    text: "",
    valid: true,
    BarraTablaDinamicaAprir: false,
    BarraSecundariaAprir: false,

    headers: [{ text: "Tipo Clientes", value: "descripcion" }],

    slotlist: [
      { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
      {
        dt0: "descripcion",
        dt1: null,
        dt2: null,
        dt3: 1,
        dt4: "Descripcion:"
      },
      { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
    ],

    slotHtabla: [
      { text: "Código", value: "codigo" },
      { text: "Descripcion", value: "descripcion" }
    ],

    list: [],
    search: "",
    acti_tb_data: false,
    Elim_notif: {
      estado: false,
      nombre: "¿Seguro que desea anular este registro?"
    },

    aalert: {
      estado: false,
      color: null
    },

  }),


  //   destroyed() {
  //     location.reload();
  //   },
  methods: {
    currencyFormatter,
  FormatoFecha,
  HoraFormatter,
  HoraFormatter2,
  RedondeoValor,
  RedondeoBasico,
  RedondeoValorCantRed,
  fechaNueva,
  getParamFecha,

    onResize(e) {

      console.log("imprii ")

      console.log(e)
      this.windowSize = e


    },

    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir;

    },

    datostabla(e) {

      this.DiarioCompras = e;
      this.acti_tb_data = false
    },
    save() { },
    remove() { },
    eliminar() { },
    anular() { },
    imprimirList() { },
    DDataReporteBasico() { },

    validarObjecto() {

      var where = `activada= true and facturas_proveedores.fecha >= ' ${new Date(this.DiarioCompras.desde).toISOString().substr(0, 10)} ' and facturas_proveedores.fecha  <=' ${new Date(this.DiarioCompras.hasta).toISOString().substr(0, 10)} ' `
      var s = ""
      //where+=` and fv.fecha >= ' ${new Date(this.DiarioCompras.desde).toISOString().substr(0,10)} ' and fv.fecha  <=' ${new Date(this.DiarioCompras.hasta).toISOString().substr(0,10)} '`

      if (this.DiarioCompras.tipoFactura != null) {
        if (this.DiarioCompras.tipoFactura.codigo == 1) {
          s = s + "CONTADO";
          where += " and facturas_proveedores.diascredito=0 ";
        }
        if (this.DiarioCompras.tipoFactura.codigo == 2) {
          s = s + "CREDITO";
          where += " and facturas_proveedores.diascredito>0 ";
        }

      } else {
        s = s + "CONTADO y CREDITO";
      }

      if (this.DiarioCompras.proveedor != null) {
        where += ` and facturas_proveedores.proveedor = ${this.DiarioCompras.proveedor.codigo}`;
      }

      if (this.DiarioCompras.documento != null && this.DiarioCompras.documento.codigo != undefined) {
        where += ` and facturas_proveedores.documento = ${this.DiarioCompras.documento.codigo}`;
        this.DiarioComprasLink.documentoFiltro = this.DiarioCompras.documento.descripcion || "";
      } else {
        this.DiarioComprasLink.documentoFiltro = "";
      }

      this.DiarioComprasLink.where = where
      this.DiarioComprasLink.Condicion = s
      this.DiarioComprasLink.fechaini = JSON.parse(JSON.stringify(this.DiarioCompras.desde))
      this.DiarioComprasLink.fechafin = JSON.parse(JSON.stringify(this.DiarioCompras.hasta))

    },



    newwnuevo() {
      (this.DiarioCompras = {
        activo: true,
        borrado: false,
        codigo: 0,
        descripcion: "",
        descripcionOriginal: "",
        fechaCreacion: "",
        fechaModificacion: "",
        usuarioCreacion: "",
        usuarioModificacion: "",
        documento: null
      }),
        EventBus.$emit("actualizaBarraBusqueda2");
    },




    SelctCbTipoFactura() {
      if (this.DiarioCompras.tipoFactura == null) {

        this.DiarioCompras.tipoFactura = ''
      }

      if (this.DiarioCompras.tipoFactura.codigo == undefined) {

        this.alerta("Seleccione un tipo Factura", "error");
        this.DiarioCompras.tipoFactura = ''
        return

      }

    },



    cargarProveedor() {

      this.$axios.get(this.$hostname + this.$hName + '/proveedores/findallbyDesc/25/0/*', { headers: this.$store.getters.GetheadersAxios })
        .then(res => (this.Rproveedor = res.data))

    },

    cargarDocumento() {
      this.$axios.get(this.$hostname + this.$hName + "/documentoscxp/findAllDocumentosFacturasProveedores",
        { headers: this.$store.getters.GetheadersAxios }
      ).then((res) => (this.RDocumento = res.data));
    },

    SelctCbDocumento() {
      if (this.DiarioCompras.documento == null || this.DiarioCompras.documento === '') {
        this.DiarioCompras.documento = ''
        return
      }

      if (this.DiarioCompras.documento.codigo == undefined) {
        this.alerta("Seleccione un documento", "error");
        this.DiarioCompras.documento = ''
        return
      }
    },


    SelctCbProveedor() {
      if (this.DiarioCompras.proveedor == null) {

        this.DiarioCompras.proveedor = ''
      }

      if (this.DiarioCompras.proveedor.codigo == undefined) {

        this.alerta("Seleccione un proveedor", "error");
        this.DiarioCompras.proveedor = ''

        //qlq2

        return

      }

    },

    CbFilProveedor(e) {

      if (e.target.value.length >= 0) {
        this.$axios
          .get(
            this.$hostname +
            this.$hName +
            "/proveedores/findallbyDesc/25/0/" +
            (e.target.value === "" ? "*" : e.target.value),
            { headers: this.$store.getters.GetheadersAxios }
          )
          .then((res) => (this.Rproveedor = res.data));
      }

    },


    BlurDesde() {

      if (this.DiarioCompras.desde.toString().length == 0) {
        this.DiarioCompras.desde = this.fechaNueva()
      }

    },


    BlurHasta() {

      if (this.DiarioCompras.hasta.toString().length == 0) {
        this.DiarioCompras.hasta = this.fechaNueva()
      }

    },










    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);

        this.newwnuevo();
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e);

        this.ejecucion = false;
      }
    },




    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data;
      this.filtro();
    },

    async filtro() { }
  }
};
</script>

<style>
</style>
